'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var _getFormData = require('get-form-data');

var _getFormData2 = _interopRequireDefault(_getFormData);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var AutoForm = _react2['default'].createClass({
  displayName: 'AutoForm',

  propTypes: {
    component: _react.PropTypes.any,
    onChange: _react.PropTypes.func,
    onSubmit: _react.PropTypes.func,
    trim: _react.PropTypes.bool,
    trimOnSubmit: _react.PropTypes.bool
  },

  getDefaultProps: function getDefaultProps() {
    return {
      component: 'form',
      trim: false,
      trimOnSubmit: false
    };
  },

  _onChange: function _onChange(e) {
    var _e$target = e.target;
    var form = _e$target.form;
    var name = _e$target.name;

    var data = _getFormData.getNamedFormElementData(form, name, { trim: this.props.trim });
    var change = {};
    change[name] = data;
    this.props.onChange(e, name, data, change);
  },

  _onSubmit: function _onSubmit(e) {
    var data = _getFormData2['default'](e.target, { trim: this.props.trimOnSubmit || this.props.trim });
    this.props.onSubmit(e, data);
  },

  render: function render() {
    var _props = this.props;
    var children = _props.children;
    var Component = _props.component;
    var onChange = _props.onChange;
    var onSubmit = _props.onSubmit;
    var trim = _props.trim;
    var trimOnSubmit = _props.trimOnSubmit;

    var props = _objectWithoutProperties(_props, ['children', 'component', 'onChange', 'onSubmit', 'trim', 'trimOnSubmit']);

    return _react2['default'].createElement(Component, _extends({}, props, {
      children: children,
      onChange: onChange && this._onChange,
      onSubmit: onSubmit && this._onSubmit
    }));
  }
});

exports['default'] = AutoForm;
module.exports = exports['default'];
// eslint-disable-line no-unused-vars


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-auto-form/lib/index.js
 ** module id = 178
 ** module chunks = 0
 **/